import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import AuthButton from '../../../User/AuthButton/index.js';
import ProfileIcon from '../../../User/ProfileIcon.js/index.js';
import { NavTabs, Row } from '../../Blocks/index.js';
import PageTitle from '../PageTitle/index.js';
import Header from './Block/index.js';
import HeaderTab from './Tab/index.js';


const GlobalHeader = ({ rootUrl, tabs, ...props }) => {
  const [activeTab, setActiveTab] = useState({});

  const navigate = useNavigate();
  const location = useLocation();

  const changeTab = newTabName => {
    const newTab = tabs.find(t => t.name === newTabName)
    navigate(`/${rootUrl}/${newTab.path}`, { replace: true })
  }

  useEffect(() => {
    // console.log(location.pathname)
    setActiveTab(
      tabs.find(t => { console.log(location.pathname, '  ', `/${rootUrl}/${t.path}`); return location.pathname === `/${rootUrl}/${t.path}` })
      || tabs.find(t => { return location.pathname.startsWith(`/${rootUrl}/${t.path}`) })
    );
  }, [tabs]);


  return (
    <Header isResponsive={true}>
      <PageTitle title={activeTab?.name || ''} />

      <Row style={{ width: '100%' }}>
        <HeaderTab>
          <NavTabs getTabName={true} open_tab={activeTab?.name} tabs={tabs.map(t => t.name)} onChange={changeTab} />
        </HeaderTab>

        <ProfileIcon />
        <AuthButton />
        {props.children}
      </Row>
    </Header>
  );
};


export default GlobalHeader;
